exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n  padding: 25px;\n}\n\n.card {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 800px;\n  border: none;\n}\n\n.img-resize {\n  margin-left: auto;\n  margin-left: auto;\n  max-height:400px;\n  max-width: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n\n}\n\n.card-title {\n  letter-spacing: 0.025em;\n  line-height: 1.2;\n  margin-bottom: 5px;\n  font-family: \"Tw Cen W01 Medium\", sans-serif;\n  font-size: 38px;\n  font-size: 2.375rem;\n  font-style: normal;\n  font-weight: normal;\n  display: block;\n}\n\n.card-price {\n  font-size: 19px;\n}\n\n.card-text {\n  line-height: 1.9;\n  margin-bottom: 45px;\n  font-size: 14px;\n  font-size: 0.875rem;\n}\n\nh2 {\n  text-align: center; */\n  text-transform: uppercase;\n  letter-spacing: 0.115em;\n  font-family: \"Tw Cen W01 Light\", sans-serif;\n  font-size: 16px;\n  font-size: 1rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/julia/Desktop/kinfolk/src/app/shopping-item/shopping-item.component.css
// module id = ../../../../../src/app/shopping-item/shopping-item.component.css
// module chunks = main